import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { OverviewLink } from 'components';

export default class DiscountCard extends Component {

  static propTypes = {
    buttonType: PropTypes.string,
    text: PropTypes.object.isRequired,
    href: PropTypes.string,
    theme: PropTypes.string,
  }

  constructor(props) {
    super(props);
    this.trackClick = this.trackClick.bind(this);
  }

  trackClick(linkText) {
    window.analytics.track(
      `Clicked ${linkText}`,
      { location: 'account-overview',
        user: {
          type: 'sl_premium'
        }
      }
    );
  }

  render() {
    const {
      text,
      href,
      theme,
    } = this.props;

    return (
      <div className={`discount__card--${theme}`}>
        <div className="discount__card">
          <div>
            <p className="discount__card__title">{text.title}</p>
          </div>
          <div>
            <p className="discount__card__message">{text.message}</p>
          </div>
          <div>
            <p className="discount__card__message">Email
              <a
                className="discount__card__link"
                onClick={() => this.trackClick('Email support@surfline.com to receive your discount code.')}
                href="mailto:support@surfline.com"
              >  support@surfline.com
              </a> to receive your discount code.
            </p>
            {/* <OverviewAction onClickHandler={this.trackGetCode} theme={this.props.buttonType} hrefExternal={href}>
              {text.link_text}
            </OverviewAction> */}
          </div>
          <div className="discount__card__link__secondary">
            <OverviewLink onClickHandler={() => this.trackClick(text.link_text_secondary)} theme={'secondary'} hrefExternal={href}>
              {text.link_text_secondary}
            </OverviewLink>
          </div>
        </div>
      </div>
    );
  }
}
